/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum PlaceType {
  Unknown = 0,
  Point = 1,
  TransitStation = 2,
}
